'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _taskList = require('./taskList.html');

var _taskList2 = _interopRequireDefault(_taskList);

var _taskListFilterModal = require('./taskListFilterModal.html');

var _taskListFilterModal2 = _interopRequireDefault(_taskListFilterModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var taskList = {
    bindings: {
        activities: '=?',
        activityCount: '=?',
        defaultTab: '@',
        deleteActivities: '=?',
        deleteTasks: '=?',
        filterIndicationText: '=?',
        isFilterActive: '=?',
        onSearch: '=?',
        openModal: '=?',
        parameters: '=',
        referencePage: '@',
        referenceId: '@',
        searchText: '=?',
        showCheckboxes: '=?',
        taskCount: '=?',
        tasks: '=?',
        taskType: '=?',
        onExport: '=?'
    },

    template: _taskList2.default,

    controller: function controller($scope, ApiTasks, $ionicLoading, $ionicModal, ApiCampaigns, ApiTeam, ApiUser, filterHistory, $filter, $rootScope, FileSaver, sentEmailPopup, MessageBox) {
        var _this = this;

        ApiUser.getUser().then(function (user) {
            _this.user = user;
        });

        this.$rootScope = $rootScope;
        this.taskType = 'TASK';
        this.ApiTasks = ApiTasks;
        this.ApiCampaigns = ApiCampaigns;
        this.ApiTeam = ApiTeam;
        this.modal = $ionicModal.fromTemplate(_taskListFilterModal2.default, {
            scope: $scope
        });
        this.loading = [];
        this.filter = { assignees: [], campaigns: [] };
        this.filterHistory = filterHistory;
        this.FileSaver = FileSaver;

        this.filterParameterObj = {
            stati: undefined,
            searchText: '',
            firstQueryResult: undefined,
            sortOrder: 'DUE_DATE'
        };

        this.taskMoreData = false;
        this.activitiesMoreData = false;
        this.taskloadingData = true;
        this.activityloadingData = true;

        var self = this;
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParam) {
            if (self.closeModal() != null) self.closeModal();
        });

        this.init = function () {
            _this.filterLoaded = [0, 0];
            _this.preLoadFilter();
            _this.memberDetails();
            _this.campaignDetails();
            _this.loadTasks(_this.filterParameterObj);
            _this.selectSearchTextFromLocalStorage();

            if (_this.$rootScope.$state.name === 'tasks') {
                _this.displayTab();
            } else {
                if (_this.defaultTab && _this.defaultTab === 'HISTORY') {
                    sessionStorage.setItem('task-tab', 'ACTIVITY');
                    _this.taskType = 'ACTIVITY';
                } else {
                    sessionStorage.setItem('task-tab', 'TASK');
                    _this.taskType = 'TASK';
                }
            }
        };

        this.selectSearchTextFromLocalStorage = function () {
            var filter = _this.filterHistory.readFilter(_this.referencePage) || {};
            if (filter.searchText) _this.searchText = filter.searchText;
        };

        this.assignDefaultFilters = function () {
            if (_this.parameters) {
                if (_this.parameters.campaignIds) {
                    _this.filterParameterObj.campaignIds = _this.parameters.campaignIds;
                    _this.referenceId = _this.parameters.campaignIds[0];
                }
                if (_this.parameters.contactExtensionIds) {
                    _this.filterParameterObj.contactExtensionIds = _this.parameters.contactExtensionIds;
                }
                if (_this.parameters.customerInvestorIds) {
                    _this.filterParameterObj.customerInvestorIds = _this.parameters.customerInvestorIds;
                }
                if (_this.parameters.investorIds) {
                    _this.filterParameterObj.investorIds = _this.parameters.investorIds;
                }
                if (_this.parameters.taskRelations) {
                    _this.filterParameterObj.taskRelations = _this.parameters.taskRelations;
                }
                if (_this.parameters.currentUserId) {
                    _this.filterParameterObj.assigneeIds = [_this.parameters.currentUserId];
                    _this.filter.assigneeIds = [_this.parameters.currentUserId];
                }
            }
        };

        this.memberDetails = function () {
            _this.ApiTeam.getTeamMembers().then(function (response) {
                _this.filter.assignees = response || [];
                _this.checkOnAssigneIfPreSelectedInCampaignDeatilPage();
                if (_this.parameters && _this.parameters.currentUserId) {
                    _this.filter.assignees.forEach(function (assignee) {
                        if (_this.filter.assigneeIds && _this.filter.assigneeIds.includes(assignee.id)) {
                            assignee.checked = true;
                        }
                    });
                }
                _this.filterLoaded.pop();
            });
        };

        this.checkOnAssigneIfPreSelectedInCampaignDeatilPage = function (assignees) {
            if (_this.filter && _this.filter.assignees && _this.referencePage && _this.filter.assigneeIds && _this.referencePage == 'campaign-detail') {
                _this.filter.assignees.forEach(function (assignee) {
                    assignee.checked = _this.filter.assigneeIds.includes(assignee.id);
                });
            }
        };

        this.includeDefaultAccountInFilterIfRedirectedFromAccountDetailPage = function (searchParams) {
            if (_this.parameters && _this.parameters.investorIds && (_this.referencePage == 'account-detail' || _this.referencePage == 'customerInvestorsDetail' || _this.referencePage == 'investorsDetail')) {
                searchParams.investorIds = _this.parameters.investorIds;
            }
        };

        this.includeDefaultContactInFilterIfRedirectedFromContactDetailPage = function (searchParams) {
            if (_this.parameters && _this.parameters.contactExtensionIds && _this.referencePage == 'contact-details') {
                searchParams.contactExtensionIds = _this.parameters.contactExtensionIds;
            }
        };

        this.campaignDetails = function () {
            if (_this.parameters && _this.parameters.campaignIds) {
                _this.ApiCampaigns.getCampaign(_this.parameters.campaignIds[0]).then(function (response) {
                    if (undefined != response) {
                        if (_this.filter.campaignIds && _this.filter.campaignIds.includes(response.campaignId)) {
                            response.checked = true;
                        }
                        _this.filter.campaigns = [response];
                    } else {
                        _this.filter.campaigns = [];
                    }
                    _this.filterLoaded.pop();
                });
            } else {
                _this.ApiCampaigns.getCampaignsMinimal().then(function (response) {
                    _this.filter.campaigns = response || [];
                    _this.filter.campaigns.forEach(function (campaign) {
                        if (_this.filter.campaignIds && _this.filter.campaignIds.includes(campaign.campaignId)) {
                            campaign.checked = true;
                        }
                    });
                    _this.filterLoaded.pop();
                });
            }
        };

        this.getFilteredTasks = function (parameters) {
            return _this.ApiTasks.getTasksFiltered(parameters);
        };

        this.getFilteredActivities = function (parameters) {
            return _this.ApiTasks.getTasksFiltered(parameters);
        };

        this.filteredCount = function (parameters) {
            return _this.ApiTasks.getTasksFilteredCount(parameters);
        };

        this.loadTasks = function (parameters) {
            parameters.campaignIds = parameters.campaignIds || [];
            parameters.assigneeIds = parameters.assigneeIds || [];
            parameters.customerInvestorIds = parameters.customerInvestorIds || [];
            _this.includeDefaultAccountInFilterIfRedirectedFromAccountDetailPage(parameters);
            _this.includeDefaultContactInFilterIfRedirectedFromContactDetailPage(parameters);
            _this.getTasks(angular.copy(parameters));
            _this.getActivities(angular.copy(parameters));
            _this.checkIfFilterIsActive(parameters);
            _this.displayTab();
        };

        this.checkIfFilterIsActive = function (parameters) {
            _this.filterIndicationText = _this.getFilterIndicationText(parameters);
            _this.isFilterActive = _this.filterIndicationText.length > 0;
        };

        this.getFilterIndicationText = function (filterParameters) {
            var text = '';
            if (filterParameters.campaignIds.length > 0) {
                if (!(_this.parameters && _this.parameters.campaignIds)) {
                    text = text + $filter('translate')('CAMPAIGNS') + ', ';
                }
            }
            if (filterParameters.assigneeIds.length > 0) text = text + $filter('translate')('TEAM_MEMBERS') + ', ';
            if (text.length > 0) {
                text = 'Filter by: ' + text.substring(text.length - 2, 0);
            }
            return text;
        };

        this.getTasks = function (parameters) {
            _this.taskloadingData = true;
            var params = _this.setFilterBasedOnTaskType('TASKS', parameters);
            _this.getFilteredTasks(params).then(_this.setTasks);
            if (_this.referencePage == 'tasks') {
                _this.filteredCount(parameters).then(function (response) {
                    _this.taskCount = response || 0;
                });
            }
        };

        this.getActivities = function (parameters) {
            _this.activityloadingData = true;
            var params = _this.setFilterBasedOnTaskType('ACTIVITY', parameters);
            _this.getFilteredActivities(parameters).then(_this.setActivities);
            if (_this.referencePage == 'tasks') {
                _this.filteredCount(parameters).then(function (response) {
                    _this.activityCount = response || 0;
                });
            }
        };

        this.setTasks = function (tasks) {
            _this.tasks = tasks || [];
            if (_this.tasks.length < 50) {
                _this.taskMoreData = false;
            } else {
                _this.taskMoreData = true;
            }
            _this.taskloadingData = false;
        };

        this.setActivities = function (activities) {
            _this.activities = activities || [];
            if (_this.activities.length < 50) {
                _this.activitiesMoreData = false;
            } else {
                _this.activitiesMoreData = true;
            }
            _this.activityloadingData = false;
        };

        this.addTasks = function (tasks) {
            if (!tasks) {
                _this.taskMoreData = false;
            } else {
                _this.taskMoreData = tasks.length < 50 ? false : true;
                _this.tasks = _this.tasks.concat(tasks);
                $scope.$broadcast('scroll.infiniteScrollComplete');
            }
            _this.taskloadingData = false;
        };

        this.getMoreTasks = function () {
            _this.taskloadingData = true;
            var parameters = _this.setFilterBasedOnTaskType('TASK', _extends({}, _this.filterParameterObj));
            parameters.firstQueryResult = _this.tasks && _this.tasks.length;
            _this.getFilteredTasks(parameters).then(_this.addTasks);
        };

        this.getMoreActivities = function () {
            _this.activityloadingData = true;
            var parameters = _this.setFilterBasedOnTaskType('ACTIVITY', _extends({}, _this.filterParameterObj));
            parameters.firstQueryResult = _this.activities && _this.activities.length;
            _this.getFilteredTasks(parameters).then(_this.addActivities);
        };

        this.addActivities = function (activities) {
            if (!activities) {
                _this.activitiesMoreData = false;
            } else {
                _this.activitiesMoreData = activities.length < 50 ? false : true;
                _this.activities = _this.activities.concat(activities);
                $scope.$broadcast('scroll.infiniteScrollComplete');
            }
            _this.activityloadingData = false;
        };

        this.deleteTask = function (task, index, type) {
            _this.ApiTasks.deleteTask(task.task.taskId).then(function (res) {
                // delete response(res) is null. so the below check is correct.
                // please don't remove
                if (res == null) {
                    _this.deleteEvent(task);
                    if ('TASK' === type) {
                        _this.tasks.splice(index, 1);
                        if (_this.referencePage == 'tasks') {
                            _this.taskCount--;
                        }
                    } else if ('ACTIVITY' === type) {
                        _this.activities.splice(index, 1);
                        if (_this.referencePage == 'tasks') {
                            _this.activityCount--;
                        }
                    }
                }
            });
        };

        this.deleteEvent = function (task) {
            if (ionic.Platform.isWebView()) {
                var taskCalendar = task.task;
                var taskDeleteStart = new Date(taskCalendar.startDate);
                var taskDeleteEnd = new Date(taskCalendar.dueDate);
                var id = taskCalendar.taskId.toString();
            }
        };

        this.openModal = function () {
            _this.allMembersSelected = false;
            _this.allCampaignSelected = false;
            _this.existingFilter = angular.copy(_this.filter);
            _this.modal.show();
        };

        this.closeModal = function () {
            _this.modal.hide();
        };

        this.cancelModal = function () {
            _this.filter = _this.existingFilter;
            _this.closeModal();
        };

        this.selectAllMembers = function () {
            _this.filter.assignees.forEach(function (assignee) {
                assignee.checked = _this.allMembersSelected;
            });
        };

        this.selectAllCampaigns = function () {
            _this.filter.campaigns.forEach(function (campaign) {
                campaign.checked = _this.allCampaignSelected;
            });
        };

        this.onApplyFilter = function () {
            var searchParameters = _extends({}, _this.filterParameterObj);
            searchParameters.searchText = _this.filter.searchText;
            searchParameters.assigneeIds = _this.getCheckedAssignees();
            searchParameters.campaignIds = _this.getCheckedCampaigns();
            searchParameters.campaignIds = searchParameters.campaignIds.concat(_this.getCampaignIdFromCampaignPageIfExists());
            _this.saveSearchParameterInHistory(searchParameters);
            _this.loadTasks(searchParameters);
            _this.closeModal();
        };

        this.getCheckedAssignees = function () {
            var assigneeIds = [];
            _this.filter.assignees.map(function (a) {
                if (a && a.checked) assigneeIds.push(a.id);
            });
            return assigneeIds;
        };

        this.getCheckedCampaigns = function () {
            var campaignIds = [];
            _this.filter.campaigns.map(function (a) {
                if (a.checked) campaignIds.push(a.campaignId);
            });
            return campaignIds;
        };

        this.getCampaignIdFromCampaignPageIfExists = function () {
            if (_this.parameters && _this.parameters.campaignIds) {
                return _this.parameters.campaignIds;
            } else {
                return [];
            }
        };

        this.saveSearchParameterInHistory = function (searchParameter) {
            var searchParameterClone = JSON.parse(JSON.stringify(searchParameter));
            // if(searchParameterClone.searchText) delete searchParameterClone.searchText;
            if (_this.referencePage != 'tasks') {
                delete searchParameterClone.campaignIds;
                delete searchParameterClone.contactExtensionIds;
            }
            _this.filterHistory.saveFilter(searchParameterClone, _this.referencePage);
        };

        this.onFilter = function () {
            _this.onApplyFilter();
            return;
        };

        this.removeAssigneeFilter = function (assignee) {
            assignee.checked = false;
            _this.onFilter();
        };

        this.removeCampaignFilter = function (campaign) {
            campaign.checked = false;
            _this.onFilter();
        };

        this.removeAllFilters = function () {
            _this.filter.campaigns.map(function (item) {
                item.checked = false;
            });

            _this.filter.assignees.map(function (item) {
                item.checked = false;
            });

            _this.onFilter();
        };

        this.deleteTasks = function () {
            _this.showCheckboxes = !_this.showCheckboxes;
            var taskIds = _this.tasks.filter(function (task) {
                return task.selected;
            }).map(function (task) {
                return task.task.taskId;
            });
            _this.ApiTasks.deleteTasks(taskIds).then(function (res) {
                if (res !== undefined) {
                    _this.tasks.filter(function (task) {
                        return task.selected;
                    }).forEach(function (task) {
                        _this.deleteEvent(task);
                        _this.tasks.splice(_this.tasks.indexOf(task), 1);
                        if (_this.referencePage == 'tasks') {
                            _this.taskCount--;
                        }
                    });
                }
            });
        };

        this.deleteActivities = function () {
            _this.showCheckboxes = !_this.showCheckboxes;
            var taskIds = _this.activities.filter(function (task) {
                return task.selected;
            }).map(function (task) {
                return task.task.taskId;
            });
            _this.ApiTasks.deleteTasks(taskIds).then(function (res) {
                if (res !== undefined) {
                    _this.activities.filter(function (task) {
                        return task.selected;
                    }).forEach(function (task) {
                        _this.deleteEvent(task);
                        _this.activities.splice(_this.activities.indexOf(task), 1);
                        if (_this.referencePage == 'tasks') {
                            _this.activityCount--;
                        }
                    });
                }
            });
        };

        this.preLoadFilter = function () {
            _this.assignDefaultFilters();
            var preFilter = _this.filterHistory.readFilter(_this.referencePage);
            if (preFilter) {
                angular.extend(_this.filterParameterObj, preFilter);
                angular.extend(_this.filter, preFilter);
            }
        };

        this.onSearch = function (search) {
            _this.filter.searchText = search;
            _this.onFilter();
        };

        this.setCurrentTab = function (tabName) {
            _this.taskType = tabName || 'TASK';
            sessionStorage.setItem('task-tab', tabName);
        };

        this.displayTab = function () {
            var currentTab = sessionStorage.getItem('task-tab') || 'TASK';
            _this.taskType = currentTab;
        };

        this.setFilterBasedOnTaskType = function (type, params) {
            switch (type) {
                case 'ACTIVITY':
                    params.stati = ['DONE'];
                    params.sortDirection = 'DESC';
                    break;
                case 'TASKS':
                    params.stati = ['OPEN', 'OVERDUE'];
                    params.sortDirection = 'ASC';
                    break;
            }
            return params;
        };

        this.exportTasks = function () {
            $ionicLoading.show();

            var parameters = _extends({}, _this.filterParameterObj);
            parameters.searchText = _this.filter.searchText;
            parameters.assigneeIds = _this.getCheckedAssignees();
            parameters.campaignIds = _this.getCheckedCampaigns();
            parameters.campaignIds = parameters.campaignIds.concat(_this.getCampaignIdFromCampaignPageIfExists());

            parameters.campaignIds = parameters.campaignIds || [];
            parameters.assigneeIds = parameters.assigneeIds || [];
            parameters.customerInvestorIds = parameters.customerInvestorIds || [];
            _this.includeDefaultAccountInFilterIfRedirectedFromAccountDetailPage(parameters);
            _this.includeDefaultContactInFilterIfRedirectedFromContactDetailPage(parameters);

            var params = _this.setFilterBasedOnTaskType('TASKS', parameters);

            _this.ApiTasks.emailTasks(params).then(function (_) {
                $ionicLoading.hide();
                MessageBox.showSuccessMessage('EXPORT_TASK', 'SENT');
            });
        };

        this.onExport = function () {
            sentEmailPopup.show(_this.user.firstName + ' ' + _this.user.name, _this.exportTasks);
        };
    }
};

exports.default = taskList;


/** WEBPACK FOOTER **
 ** ./src/app/directives/taskList/taskList.js
 **/